import { create } from 'zustand'
import { api } from '../services/api.js'

export const useAuthStore = create((set, get) => ({
  token: localStorage.getItem('gl_token') || null,
  user: JSON.parse(localStorage.getItem('gl_user') || 'null'),

  login: (token, user) => {
    localStorage.setItem('gl_token', token)
    localStorage.setItem('gl_user', JSON.stringify(user))
    set({ token, user })
  },

  // Patch the user object locally — used for optimistic state updates
  // (e.g. dismissing onboarding) so the UI reflects the change before the
  // /auth/me round-trip lands. Synchronous, no API call.
  setUser: (user) => {
    localStorage.setItem('gl_user', JSON.stringify(user))
    set({ user })
  },

  logout: () => {
    localStorage.removeItem('gl_token')
    localStorage.removeItem('gl_user')
    set({ token: null, user: null })
  },

  // Refetch the current user from the API. Called on app mount so tier
  // changes made server-side (admin upgrades, Stripe webhooks) show up
  // without requiring a logout/login. A 401 means the token is dead —
  // wipe the session instead of leaving a stale user object in place.
  refresh: async () => {
    if (!get().token) return
    try {
      const fresh = await api.get('/auth/me')
      localStorage.setItem('gl_user', JSON.stringify(fresh))
      set({ user: fresh })
    } catch (err) {
      if (err.status === 401) get().logout()
    }
  },
}))
